module.exports = __webpack_public_path__ + "static/media/-_Branding & Communication.b24347bc.png";